import React from 'react';
import './styles.css';
import Hand from '../../assets/hand.svg';
import Handshake from '../../assets/Handshake.svg';
import Children from '../../assets/children.svg';
import Unifor from '../../assets/logos/Unifor.svg';
import Vortex from '../../assets/logos/Vortex.svg';
import Unimed from '../../assets/logos/Unimed.svg';
import Estimule from '../../assets/logos/estimule_logo.svg';
import { Link } from 'react-router-dom';
const orientadores = [
  'Carlos Jardel Teixeira Gomes',
  'Christina César Praça Brasil',
  'Consuelo Oliveira Pontes',
  'Darival Bringel de Olinda',
  'Erick Tomé de Lima',
  'Fabiana Neiva Veloso Brasileiro',
  'Felícia Gabler',
  'Inácio Dutra de Melo Júnior',
  'José Eurico de Vasconcelos Filho',
  'José Fernando Ferreira Neto',
  'Yuri Nekan Soares Fontes',
  'George Moreno De Oliveira',
  'Gilberto Fábio Egypto da Silva Neto',
  'Joel Sotero da Cunha Neto',
];
const colaboradores = [
  'Davi Lopes Teixeira',
  'Davi Pereira Araújo de Brito Cardoso',
  'Felipe Maia Balbueno da Silva',
  'Francisca Francisete de Sousa Nunes Queiroz',
  'Henrique Abalen Lage',
  'José Wilson Wariss Macedo Sá',
  'Larissa Macedo',
  'Letícia Albuquerque de França',
  'Lucas Cunha Matos',
  'Pedro Abreu Pimenta',
  'Guilherme Garcia Monteiro',
  'João Victor Rodrigues Barreto',
  'Valentim Araújo de Fontenele Aragão',
];
function Home() {
  return (
    <div className="home-container">
      <div className="home-frame hero">
        <img src={Estimule} alt="Estimule" />
        <Link to="/filter" className="start-button">
          INICIAR DESCOBERTA
        </Link>
      </div>
      <div className="home-frame  transform">
        <div className="transform-content">
          <h1>
            Transforme o <br /> desenvolvimento de <br />
            <strong>crianças com TEA</strong>
          </h1>
          <p>
            O Estimule nasceu para conectar ciência, afeto e praticidade. Nossa
            missão é apoiar profissionais, educadores e famílias na jornada de
            evolução de crianças com Transtorno do Espectro Autista (TEA),
            facilitando a escolha e a aplicação de atividades lúdicas
            personalizadas.
          </p>
        </div>
      </div>
      <div className="home-frame why">
        <h1>
          Por que escolher o <strong>Estimule</strong>?
        </h1>
        <div className="why-container">
          <div>
            <img src={Handshake}></img>
            <p>
              <strong>Ciência e Vivência de Mãos Dadas:</strong> Nosso catálogo
              de atividades foi criado a partir de uma ampla revisão da
              literatura científica e enriquecido com a experiência real de
              profissionais da saúde, educação, além do relato valioso de pais e
              cuidadores.
            </p>
          </div>
          <div>
            <img src={Children}></img>
            <p>
              <strong>Sob Medida para Cada Criança:</strong> Chega de perder
              tempo procurando o que fazer. Nossas atividades são categorizadas
              por  habilidades-alvo e níveis de dificuldade, tornando a escolha
              muito mais assertiva.
            </p>
          </div>
          <div>
            <img src={Hand}></img>
            <p>
              <strong>Evolução na Palma da Mão: </strong>Através de um portal
              100% responsivo, familiares e educadores ganham uma ferramenta
              poderosa para acompanhar de perto cada conquista e progresso da
              criança.
            </p>
          </div>
        </div>
      </div>
      <div className="home-frame power">
        <div className="power-container">
          <h1>O poder da parceria profissional</h1>
          <p>
            O olhar clínico faz toda a diferença: Para garantir os melhores
            resultados, o Estimule se torna ainda mais poderoso quando aliado à
            avaliação de um especialista habilitado. É esse profissional quem
            vai direcionar o tipo de atividade e o nível de dificuldade perfeito
            para impulsionar o potencial da criança de forma segura.
          </p>
        </div>
      </div>
      <div className="home-frame logos">
        <img src={Unifor} alt="Unifor" />
        <img src={Vortex} alt="Vortex" />
        <img src={Unimed} alt="Unimed" />
      </div>
      <div className="home-frame about">
        <div className="about-content">
          <p>
            O Estimule é resultado de um projeto multidisciplinar com
            professores pesquisadores e alunos das áreas de Saúde Coletiva,
            Ciências da Computação, Engenharia da Computação e Publicidade e
            Propaganda da Universidade de Fortaleza, em parceria com a Unimed
            Ceará. O objetivo do aplicativo é, através de brincadeiras com
            finalidades terapêuticas, que podem ser realizadas em domicílio ou
            ambientes de lazer, possibilitar uma ferramenta de auxílio na
            estimulação infantil de crianças com TEA (Transtorno do Espectro
            Autista).
          </p>
          <h1>
            Sobre o <strong>sistema</strong>
          </h1>
        </div>
      </div>
      <div className="home-frame footer">
        <div className="footer-container">
          <h1>
            <strong>Equipe</strong> <br /> do projeto
          </h1>
          <div className="orientadores-section">
            <h3>
              <strong>Orientadores</strong>
            </h3>
            <ul className="orientadores-list">
              {orientadores.map((nome, index) => (
                <li key={index}>{nome}</li>
              ))}
            </ul>
          </div>
          <div className="colaboradores-section">
            <h3>
              <strong>Colaboradores</strong>
            </h3>

            <ul className="colaboradores-list">
              {colaboradores.map((nome, index) => (
                <li key={index}>{nome}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
